import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'product-search',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.scss']
})
export class ProductSearchComponent implements OnInit {
  searchString: string;
  constructor(private router: Router) { }

  ngOnInit() {
  }
  searchProduct() {
    this.router.navigate(['/products'], { queryParams: { searchString: this.searchString } });
  }
}
